import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class FilterCacheService {
    private cache: Map<string, any> = new Map<string, any>();
    constructor() { }

    setFilter(key: string, filter: any): void {
        this.cache.set(key, filter);
    }
    getFilter<T>(key: string): T | null {
        return this.cache.get(key) || null;
    }
    clearFilter(key: string): void {
        this.cache.delete(key);
    }
    clearAll(): void {
        this.cache.clear();
    }

    exists(key: string): boolean {
        return this.cache.has(key);
    }
}